import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import RadioBlock from '../../../../../../components/Form/RadioBlock'
import Button from '../../../../../../components/Button'
import AdPreviewSoundControlWrapper from '../../../../../../features/components/FacebookPreviews/reusablePreviewComponents/AdPreviewSoundControlWrapper'
import Field from '../../../../../../components/Form/Field'
import FacebookSingleMediaAdPreview from '../../../../../../features/components/FacebookPreviews/FacebookSingleMediaAdPreview'
import FacebookCarouselAdPreview from '../../../../../../features/components/FacebookPreviews/FacebookCarouselAdPreview'

import useFlatFormikValues from '../../../useFlatFormikValues'

import {
  FB_PAGE_OPTION,
  FORMAT_CAROUSEL,
  FORMAT_OPTION,
  FORMAT_SINGLE,
  PRIMARY_TEXT_LIST,
  TEXT_BLANK,
  TEXT_ENTER,
  TEXT_OPTION
} from '../../../fields'

import useStyles from '../../../../../../styles/common/stepForms'

const stepFields = [PRIMARY_TEXT_LIST]

const TextStep = ({ formik, handleStepChange, isActive }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const flatFormikValues = useFlatFormikValues({
    formikValues: values,
    allowUseSingleMediaItem: false
  })

  const optionFormat = flatFormikValues[FORMAT_OPTION]

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields, values)
  }, [handleStepChange, values])

  const renderPreview = useCallback(() => {
    // This step is reusable on 2 different routes, so we need to check the format option
    if (optionFormat === FORMAT_SINGLE) {
      return <FacebookSingleMediaAdPreview formikValues={flatFormikValues} elementInProgress={FB_PAGE_OPTION} />
    }

    if (optionFormat === FORMAT_CAROUSEL) {
      return <FacebookCarouselAdPreview formikValues={flatFormikValues} elementInProgress={FB_PAGE_OPTION} />
    }
  }, [optionFormat, flatFormikValues])

  return (
    <>
      <div className={classes.stepTitle}>{t('What should the primary text be?')}</div>
      <div className={classes.stepBody}>
        <AdPreviewSoundControlWrapper
          elementInProgress={TEXT_OPTION}
          formikValues={flatFormikValues}
          isSoundDisabled={!isActive}
        >
          {renderPreview()}
        </AdPreviewSoundControlWrapper>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_text_enter"
          name={TEXT_OPTION}
          value={TEXT_ENTER}
          selectedValue={values[TEXT_OPTION]}
          label={t('Enter primary text')}
        >
          <Field
            placeholder={t('Primary Text')}
            formik={formik}
            // name={AD_TEXT}
            name={`${PRIMARY_TEXT_LIST}[0].text`}
            isTextarea
            hasEmojiPicker
          />
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_text_blank"
          name={TEXT_OPTION}
          value={TEXT_BLANK}
          selectedValue={values[TEXT_OPTION]}
          label={t('Leave it blank')}
        />
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default TextStep
